var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 32,
    viewBox: "0 0 40 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.419678,
    width: 40,
    height: 30.9924,
    fill: "url(#pattern0_450_1439)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_450_1439",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_450_1439",
    transform: "matrix(0.01 0 0 0.0129064 0 -0.145318)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_450_1439",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAAXNSR0IArs4c6QAAA4VJREFUeAHtnLtu1EAUQFdISIiGIHbGIhQgQQtNKqgikvjeWSVSCuig4x9ot6SlRHR8APwANNBRQJ0KBIhnhQSiACXI3l2RkF2txzO24/WJFK3kzOPec2zv+Npxr8cPBCAAAQhAAAIQgAAEIAABCEAAAhCAAAQgAAEIQAACEIAABCAAAQhAAAIQgAAEIDAmkDi3ZUU+WdWPVuQ2YBomkItQ3bPjX6P68MLq6omGw+ru9BMRBz5FXhuRS92l0mDmB0TsO1KsyHejerPB0Lo59UwhIzm7ier93srK8W7SaSDrOULy7xYj8vLsYHC+gfC6N2URIVkbI/LNOpd2j1DNGRcVMm63m4jc6w2Hx2oOszvTeQqZLI+f2bW1pDuUasy0pJA9K/Lepum1GkPtxlSlhYxWYb+Nc3e7QaqmLAOF5KewvsiTpe3tpZpCXuxpYgjJxxDZsapXFptWDdlFE5ItjVV/JSJ3agh7caeIKWTfWI+Wt7ZOLi61CjPbB3GypI3zSYGynLXKhGSrMAqU/lIqFdJkgdKoDvKLpVEQcQ77RRpL5MWZzc1z/rtMyR7I+HfXcdZRZ1S/JKprJRH7dZsVBNsPiaqnQAn4Q+DnnbarLVAixFtItQVKhJQQMlq0VFOgREhpIfmpLXqBEiFhQnJ+MQuUCIkgZHTv/qdxzvmtcae0RkgcIRnHvsjbKYj9NiEknhCj+saP/pTWCIkjxKj+MCI6BbHfJoREECKykwwGl/3Iz2iNkDAhJk0fn15fPzUDr/9mhJQWwoXhUdl5jOo7q3rVf/cv0OOoJNmWOPoiT5M0tQXQlmvSFhCNxynyx6oOK38+mBtU879DjHOfE+eul9vlPXtll/vjc+K8+wBd/fvz/sbGsifW7jWv4RTGf2H57FaVCskeA3Luhk88nW9bmRCRV9a5i50H7AugIiE8SuorYtI+phAetp5QDfiMJiRmYTAgn9Z3jSEkemGw9VQDEggUUk1hMCCf1nctK6TSwmDrqQYkUEZI5YXBgHxa39VLSF2FwdZTDUigqBAj8pVXawSALtq1oBAKg0WBhrabI4TCYChg3/4zhVAY9EUZp/1UIRQG48AtM8r/L8G0qg94CWYZkpH6ZK+JzZ6ltWn6wareijQsw0AAAhCAAAQgAAEIQAACEIAABCAAAQhAAAIQgAAEIAABCEAAAhCAAAQgAAEIQOAIEvgLSEeVYab0O1wAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForward);
export default __webpack_public_path__ + "static/media/forward.56889354794b96e092c2677378fa9d47.svg";
export { ForwardRef as ReactComponent };